module.exports = __webpack_public_path__ + "img/saveWhite.a1f23194.svg";